
 function switchVisibleall() {
   $('.wrapper_t').removeClass().addClass('wrapper');
   				$('.wrapper').css('display','');
                $('.3').css('display','');
				$('.4').css('display','');
   			   $('.a').css('display','');
               $('.b').css('display','');
               $('.c').css('display','');
               $('.d').css('display','');
               $('.e').css('display','');
               $('.f').css('display','');
               $('.g').css('display','');
               $('.h').css('display','');
               $('.i').css('display','');
               $('.j').css('display','');
               $('.k').css('display','');
               $('.l').css('display','');
               $('.m').css('display','');
               $('.n').css('display','');
               $('.o').css('display','');
               $('.p').css('display','');
               $('.q').css('display','');
               $('.r').css('display','');
               $('.s').css('display','');
               $('.t').css('display','');
               $('.u').css('display','');
               $('.v').css('display','');
               $('.w').css('display','');
               $('.x').css('display','');
               $('.y').css('display','');
               $('.z').css('display',''); 
    $("html, body").animate({ scrollTop: 0 }, "slow");
   				$('.a').css('text-decoration','none');
               $('.4').css('text-decoration','none');
 }
function switchVisiblepp1() {
            if (document.getElementById('3')) {
                if (document.getElementById('3').style.display == 'none') {
                 /* $('.4').css('display','block');
                  $('.wrapper').css('display','block');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.44').css('text-decoration','underline');
                  $('.b1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.a1').css('text-decoration','none');
                  */
                }
                else {
                  $('.33').css('display','block');
                  $('.wrapper').css('display','block');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.a').css('display','none');
                  $('.4').css('display','none');
                  $('.33').css('text-decoration','underline');
                  $('.44').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.a1').css('text-decoration','none');
                }
            }
}
   function switchVisiblepp() {
            if (document.getElementById('4')) {
                if (document.getElementById('4').style.display == 'none') {
                 /* $('.4').css('display','block');
                  $('.wrapper').css('display','block');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.44').css('text-decoration','underline');
                  $('.b1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.a1').css('text-decoration','none');
                  */
                }
                else {
                  $('.4').css('display','block');
                  $('.wrapper').css('display','block');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.a').css('display','none');
                  $('.3').css('display','none');
                  $('.44').css('text-decoration','underline');
                  $('.33').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.a1').css('text-decoration','none');
                }
            }
}
 function switchVisiblea() {
            if (document.getElementById('a')) {
                if (document.getElementById('a').style.display == 'none') {
                 /* $('.a').css('display','block');
                  $('.wrapper').css('display','block');
                  $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.a1').css('text-decoration','underline');
                  $('.b1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                 
                  $('.wrapper').css('display','block');
                  $('.wrapper').removeClass().addClass('wrapper_t');
                   $('.a').css('display','block');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.a1').css('text-decoration','underline');
                  $('.b1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
 function switchVisibleb() {
            if (document.getElementById('b')) {
                if (document.getElementById('b').style.display == 'none') {
                 /* $('.b').css('display','block');
                  $('.wrapper').css('display','block');
                  $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.b1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.b').css('display','block');
                  $('.wrapper').css('display','block');
                  $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.b1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                    $('.3').css('text-decoration','none');
                }
            }
}
 function switchVisiblec() {
            if (document.getElementById('c')) {
                if (document.getElementById('c').style.display == 'none') {
                 /* $('.c').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.c1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.c').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.c1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  $('.3').css('text-decoration','none');
                }
            }
}
   function switchVisibled() {
            if (document.getElementById('d')) {
                if (document.getElementById('d').style.display == 'none') {
                 /* $('.d').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.d1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.d').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.d1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                    $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisiblee() {
            if (document.getElementById('e')) {
                if (document.getElementById('e').style.display == 'none') {
                 /* $('.e').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.e1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.e').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                     $('.3').css('display','none');
                  $('.e1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
   function switchVisiblef() {
            if (document.getElementById('f')) {
                if (document.getElementById('f').style.display == 'none') {
                /*  $('.f').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.f1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.f').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                      $('.3').css('display','none');
                  $('.f1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
   function switchVisibleg() {
            if (document.getElementById('g')) {
                if (document.getElementById('g').style.display == 'none') {
                 /* $('.g').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.g1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.g').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.g1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  $('.3').css('text-decoration','none');
                }
            }
}
    function switchVisibleh() {
            if (document.getElementById('h')) {
                if (document.getElementById('h').style.display == 'none') {
                /*  $('.h').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.hh1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.h').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.hh1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
     function switchVisiblei() {
            if (document.getElementById('i')) {
                if (document.getElementById('i').style.display == 'none') {
                /*  $('.i').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.i1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.i').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.i1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
   function switchVisiblej() {
            if (document.getElementById('j')) {
                if (document.getElementById('j').style.display == 'none') {
                 /* $('.j').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.j1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.j').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.j1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
   function switchVisiblek() {
            if (document.getElementById('k')) {
                if (document.getElementById('k').style.display == 'none') {
                /*  $('.k').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.k1').css('text-decoration','underline')
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.k').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                    $('.3').css('display','none');
                  $('.k1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                    $('.3').css('text-decoration','none');
                }
            }
}
     function switchVisiblel() {
            if (document.getElementById('l')) {
                if (document.getElementById('l').style.display == 'none') {
                 /* $('.l').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.l1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.l').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.l1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
      function switchVisiblem() {
            if (document.getElementById('m')) {
                if (document.getElementById('m').style.display == 'none') {
                 /* $('.m').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.m1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.m').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.m1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisiblen() {
            if (document.getElementById('n')) {
                if (document.getElementById('n').style.display == 'none') {
                 /* $('.n').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.n1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.n').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.n1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
   function switchVisibleo() {
            if (document.getElementById('o')) {
                if (document.getElementById('o').style.display == 'none') {
                 /* $('.o').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.o1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                } else {
                  $('.o').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.o1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisiblep() {
            if (document.getElementById('p')) {
                if (document.getElementById('p').style.display == 'none') {
                 /* $('.p').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.p1').css('text-decoration','underline')
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.p').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.p1').css('text-decoration','underline')
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                     $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisibleq() {
            if (document.getElementById('q')) {
                if (document.getElementById('q').style.display == 'none') {
                 /* $('.q').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.q1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.q').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.q1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                    $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisibler() {
            if (document.getElementById('r')) {
                if (document.getElementById('r').style.display == 'none') {
                 /* $('.r').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.r1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.r').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.r1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                    $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisibles() {
            if (document.getElementById('s')) {
                if (document.getElementById('s').style.display == 'none') {
                 /* $('.s').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.s1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.s').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.s1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
   function switchVisiblet() {
            if (document.getElementById('t')) {
                if (document.getElementById('t').style.display == 'none') {
                 /* $('.t').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.t1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.t').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.t1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
    function switchVisibleu() {
            if (document.getElementById('u')) {
                if (document.getElementById('u').style.display == 'none') {
                 /* $('.u').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.u1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.u').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.u1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisiblev() {
            if (document.getElementById('v')) {
                if (document.getElementById('v').style.display == 'none') {
                /*  $('.v').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.v1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.v').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.v1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
  function switchVisiblew() {
            if (document.getElementById('w')) {
                if (document.getElementById('w').style.display == 'none') {
                  /* $('.w').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.w1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.w').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.w1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                    $('.3').css('text-decoration','none');
                }
            }
}
    function switchVisiblex() {
            if (document.getElementById('x')) {
                if (document.getElementById('x').style.display == 'none') {
                /*  $('.x').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.x1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.x').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.y').css('display','none');
                  $('.z').css('display','none');
                   $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.x1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
      function switchVisibley() {
            if (document.getElementById('y')) {
                if (document.getElementById('y').style.display == 'none') {
                 /* $('.y').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.y1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.y').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.z').css('display','none');
                  $('.4').css('display','none');
                  $('.3').css('display','none');
                  $('.y1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.z1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                    $('.3').css('text-decoration','none');
                }
            }
}
     function switchVisiblez() {
            if (document.getElementById('z')) {
                if (document.getElementById('z').style.display == 'none') {
                /*  $('.z').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.4').css('display','none');
                  $('.z1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                  $('.4').css('text-decoration','none');
                  */
                }
                else {
                  $('.z').css('display','block');
                  $('.wrapper').css('display','block');
                   $('.wrapper').removeClass().addClass('wrapper_t');
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                  $('.a').css('display','none');
                  $('.b').css('display','none');
                  $('.c').css('display','none');
                  $('.d').css('display','none');
                  $('.e').css('display','none');
                  $('.f').css('display','none');
                  $('.g').css('display','none');
                  $('.h').css('display','none');
                  $('.i').css('display','none');
                  $('.j').css('display','none');
                  $('.k').css('display','none');
                  $('.l').css('display','none');
                  $('.m').css('display','none');
                  $('.n').css('display','none');
                  $('.o').css('display','none');
                  $('.p').css('display','none');
                  $('.q').css('display','none');
                  $('.r').css('display','none');
                  $('.s').css('display','none');
                  $('.t').css('display','none');
                  $('.u').css('display','none');
                  $('.v').css('display','none');
                  $('.w').css('display','none');
                  $('.x').css('display','none');
                  $('.y').css('display','none');
                  $('.4').css('display','none');
                   $('.3').css('display','none');
                  $('.z1').css('text-decoration','underline');
                  $('.a1').css('text-decoration','none');
                  $('.c1').css('text-decoration','none');
                  $('.d1').css('text-decoration','none');
                  $('.e1').css('text-decoration','none');
                  $('.f1').css('text-decoration','none');
                  $('.g1').css('text-decoration','none');
                  $('.hh1').css('text-decoration','none');
                  $('.i1').css('text-decoration','none');
                  $('.j1').css('text-decoration','none');
                  $('.k1').css('text-decoration','none');
                  $('.l1').css('text-decoration','none');
                  $('.m1').css('text-decoration','none');
                  $('.n1').css('text-decoration','none');
                  $('.o1').css('text-decoration','none');
                  $('.p1').css('text-decoration','none');
                  $('.q1').css('text-decoration','none');
                  $('.r1').css('text-decoration','none');
                  $('.s1').css('text-decoration','none');
                  $('.t1').css('text-decoration','none');
                  $('.u1').css('text-decoration','none');
                  $('.v1').css('text-decoration','none');
                  $('.w1').css('text-decoration','none');
                  $('.x1').css('text-decoration','none');
                  $('.y1').css('text-decoration','none');
                  $('.b1').css('text-decoration','none');
                   $('.4').css('text-decoration','none');
                   $('.3').css('text-decoration','none');
                }
            }
}
   
  
   
  
